import { PlatformLocation } from '@angular/common';
import { Component, Inject, Optional, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Observable, of } from 'rxjs';
import { filter, first } from 'rxjs/operators';
import { BaseComponent } from '@max/shared/base-components/base.component';
import { ValidatedResponse } from '@max/shared/models/validated-response.model';
import { MvdModalService } from '@max/shared/services/modal/mvd-modal.service';
import { IncidentModalComponent } from '@max/incident/incident-modal.component';
import { IncidentCustomer } from '@max/incident/models/incident-customer.model';
import { NsfIncidentModel } from '@max/incident/models/nsf-incident.model';
import { IncidentService } from '@max/incident/services/incident.service';
import { NsfIncidentService } from '@max/incident/services/nsf-incident.service';
import { IncidentDialogContext } from '@max/incident/shared/incident-dialog-context.model';
import { CustomerSearchBarComponent } from '@max/shared/components/customer-searchbar/customer-search-bar.component';
import { IIncidentModalComponent } from '@max/incident/i-incident-modal.component';

@Component({
    selector: 'nsf-incident-modal',
    templateUrl: './nsf-incident-modal.html'
})
export class NsfIncidentModalComponent extends BaseComponent implements IIncidentModalComponent<NsfIncidentModel> {
    @ViewChild('customerSearchBar')
    public customerSearchBarComponent: CustomerSearchBarComponent;
    public form: UntypedFormGroup = null;
    public busy = false;

    constructor(
        public nsfIncidentService: NsfIncidentService,
        public dialog: MatDialogRef<IncidentModalComponent<NsfIncidentModel>>,
        @Optional()
        @Inject(MAT_DIALOG_DATA)
        public data: IncidentDialogContext<NsfIncidentModel>,
        public incidentService: IncidentService,
        private modalService: MvdModalService,
        location: PlatformLocation,
    ) {
        super();
        location.onPopState(() => this.dialog.close());
    }

    public ngOnInit(): void {
    }

    public initLookups = (lookups: any): Observable<any> => of(lookups);

    public closeModal = (result?: any): void => {
        this.dialog.close(result);
    };

    public populateModel = (form: UntypedFormGroup, model: NsfIncidentModel): void => {
        model.checkNumber = form.get('checkNumber').value;
        model.checkAmount = form.get('checkAmount').value;
        model.customerOutstandingBalanceId = 0;
    };

    public formInitialized = (form: UntypedFormGroup): void => {
        this.form = form;
        form.addControl('checkNumber', new UntypedFormControl('', Validators.required));
        form.addControl('checkAmount', new UntypedFormControl('', Validators.required));
    };

    public updateFormValidationRules = (form: UntypedFormGroup, incidentTypeId: number): void => {
    };

    public updateData = (form: UntypedFormGroup, incident: NsfIncidentModel): void => {
        form.get('checkNumber').setValue(incident.checkNumber);
        form.get('checkAmount').setValue(incident.checkAmount);
    };

    public getIncident = (incidentNumberId: number): Observable<NsfIncidentModel> => this.nsfIncidentService.getIncident(incidentNumberId);

    public save = (model: NsfIncidentModel): Observable<any> => this.nsfIncidentService.saveIncident(model);

    public loadComplete = (): void => {
    };

    public async addCustomer(event: any): Promise<void> {
        if (this.data.incident.customers.some(i => i.id == event.customerNumber)) {
            return;
        }

        let result: ValidatedResponse<IncidentCustomer> = await this.incidentService.getCustomer(event.customerNumber).pipe(first()).toPromise();

        if (result && result.result) {
            let customer: IncidentCustomer = result.result;
            this.data.incident.customers.push(customer);
        }
    }

    public confirmRemoveCustomer(customer: IncidentCustomer): void {
        this.modalService.confirm()
            .title('Warning')
            .body('If you are sure you want to delete this customer from the NSF incident record; press Delete again to complete the action.')
            .okBtn('Delete')
            .cancelBtn('Cancel')
            .open()
            .afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(() => this.removeCustomer(customer));
    }

    protected onDeleteIncident = (): void => {
        this.nsfIncidentService.deleteIncident(this.data.incident.incidentNumberId)
            .subscribe(
                _ => { },
                e => this.handleValidationResult(e),
                () => {
                    this.dialog.close(true);
                });
    };

    private removeCustomer(customer: IncidentCustomer): void {
        let index: number = this.data.incident.customers.findIndex(v => v.id == customer.id);
        this.data.incident.customers.splice(index, 1);
    }
}
